module.exports = __webpack_public_path__ + "img/repositorio_plan_estudio.ca1e6e2b.png";